/**
 * @generated SignedSource<<84f307f11f7c36bb8ae3a2c33ed32462>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsRoomPropertyEditPageQuery$variables = {
  id: string;
};
export type SettingsRoomPropertyEditPageQuery$data = {
  readonly roomProperty: {
    readonly etgKey: string | null;
    readonly name: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "RoomPropertyEditForm_roomProperty">;
  } | null;
};
export type SettingsRoomPropertyEditPageQuery = {
  response: SettingsRoomPropertyEditPageQuery$data;
  variables: SettingsRoomPropertyEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "etgKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsRoomPropertyEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoomProperty",
        "kind": "LinkedField",
        "name": "roomProperty",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RoomPropertyEditForm_roomProperty"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsRoomPropertyEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RoomProperty",
        "kind": "LinkedField",
        "name": "roomProperty",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d7026be6d46438a26a23d0899e796100",
    "id": null,
    "metadata": {},
    "name": "SettingsRoomPropertyEditPageQuery",
    "operationKind": "query",
    "text": "query SettingsRoomPropertyEditPageQuery(\n  $id: ID!\n) {\n  roomProperty(id: $id) {\n    name\n    etgKey\n    ...EntitySidebar_entity\n    ...RoomPropertyEditForm_roomProperty\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment RoomPropertyEditForm_roomProperty on RoomProperty {\n  id\n  name\n  etgKey\n}\n"
  }
};
})();

(node as any).hash = "76eb4ab23537ed8ffdfd7b0a9649a3ee";

export default node;
